export async function requestAppResourceJson<T = unknown>(
  url: string,
  init: RequestInit = {}
): Promise<T> {
  const response = await fetch(url, {
    ...init,
    credentials: 'include',
    headers: {
      'content-type': 'application/json',
      ...init.headers,
    },
  });
  if (!response.ok) {
    throw new Error(`App resource request failed: ${response.status}`);
  }
  return (await response.json()) as T;
}
